import React, { useContext } from 'react'
import IconButton from './IconButton'
import { AnimalItem, ConservationStatusItem } from '../Data/AnimalItems'
import { AnimalSponsorshipAppContext, AnimalSponsorshipState } from '../Context/AnimalSponsorshipAppContext'

interface AnimalCardProps {
    animal: AnimalItem
}

export default ({ animal }: AnimalCardProps) => {
    let {
        iconCtas
    } = useContext<AnimalSponsorshipState>(AnimalSponsorshipAppContext);
    
    return <div className="col-12 col-md-6 col-lg-4 card-column" key={animal.name}>
        <div className='card animal-card'>
            <div className='card-image animal-card-image'>
                {animal.conservationStatus != null && <div className='conservation-status'>
                    <span className={`status ${animal.conservationStatus?.key}`}>{animal.conservationStatus?.code}</span>
                    <span className='status-name'>{animal.conservationStatus?.name}</span>
                </div>}
                {animal.featured && animal.featuredText != null && animal.featuredText.length > 0 && <>
                    <div className='special-offer-text'>{animal.featuredText}</div>
                </>}
                <img src={animal.imageUrl ?? undefined} alt={animal.name ?? undefined} width="630" loading="lazy" />
            </div>
            <div className="card-body">
                <div className='animal-species'>{animal.species}</div>
                <h5 className="card-title">{animal.name}</h5>
                <p className="card-text" dangerouslySetInnerHTML={{ __html: animal.summary ?? "" }}></p>
                {animal.ctas && <div className='cta-container'>
                    <div><IconButton cta={iconCtas.get("AnimalSponsorships:SponsorThisAnimal")} id={animal.ctas.self} /></div>
                    <div><IconButton cta={iconCtas.get("AnimalSponsorships:GiftASponsorship")} id={animal.ctas.gift} /></div>
                </div>}
            </div>
        </div>
    </div>
}